
import ResponsiveTable from '../../../components/ResponsiveTable';
import PillLabel from '../../../components/PillLabel';
import { hideLoading, showLoading } from '../../../loading';
import request from '../../../request';
import swal from 'sweetalert';
import Editor from './Editor';
import { IconButton, Menu } from '@mui/material';
import { Edit as EditIcon, ExpandMore, Visibility } from '@mui/icons-material';
import { connect } from 'react-redux';
import { CASH_REQUISITION_STATUS, DEPARTMENT, USER_ROLE } from '../../../../../shared/constants';
import { formatMoney, hasIntersection } from '../../../../../shared/utils';
import DateTime from '../../../components/DateTime';
import NavigationStateSaver from '../../../components/NavigationStateSaver';
import { Link } from 'react-router';
import links from '../../../links';


class _CashRequisitionList extends NavigationStateSaver {

   state = {
      page: 0,
      limit: 10,
      cash_requisitions: null,
      total: 0,
      editorOpen: false,
      selectedCashRequisition: null,
      statusUpdatedByAnchorEl: null,
      filters: {
         status: undefined,
         from: undefined,
         to: undefined,
         department: undefined
      }
   }

   openEditor = (selectedCashRequisition=null) => {
      this.setState({ editorOpen: true, selectedCashRequisition });
   }

   closeEditor = (cashRequisition) => {

      if (cashRequisition) {
         let cash_requisitions

         if (this.state.selectedCashRequisition) {
            cash_requisitions = this.state.cash_requisitions.map(c => {
               if (c._id === cashRequisition._id)
                  return cashRequisition;
               return c;
            });
         } else {
            cash_requisitions = [ cashRequisition, ...this.state.cash_requisitions];
         }
         this.setState({ cash_requisitions });
      }

      this.setState({
         editorOpen: false,
         selectedCashRequisition: null
      });

   }

   fetchCashRequisitions = async () => {

      try {

         showLoading();

         const params = {
            page: this.state.page + 1,
            limit: this.state.limit,
         }

         const { status, from, to, department } = this.state.filters;
         if (status) params.status = status;
         if (from) params.from = from;
         if (to) params.to = to;
         if (department) params.department = department;

         const res = await request.get('/api/general/cash-requisitions', { params });
         const { cash_requisitions, total } = res.data;

         this.setState({ cash_requisitions, total });

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }
   }

   canUpdateCashRequisition = () => {
      const roles = this.props.user?.roles || [];
      const rolesThanCanUpdate = [ USER_ROLE.SUPER_ADMIN, USER_ROLE.FINANCE_MANAGER ];

      return hasIntersection(roles, rolesThanCanUpdate);
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.cash_requisitions)
         this.fetchCashRequisitions();
   }

   render() {

      const canUpdate = this.canUpdateCashRequisition();
      const isGuest = this.props.user?.roles?.length === 1 && this.props.user?.roles[0] === USER_ROLE.GUEST;

      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'amount',
                  caption: 'Amount',
                  render: amount => formatMoney(amount),
               },
               {
                  field: 'purpose',
                  caption: 'Purpose',
                  render: purpose => <div className='text-gray-600 text-xs truncate w-40'>
                     {purpose}
                  </div>
               },
               {
                  field: 'requested_by',
                  caption: 'Requested By',
                  render: requested_by => requested_by ? `${requested_by.name} ${requested_by.surname}` : '–'
               },
               {
                  field: 'department',
                  caption: 'Department',
                  render: department => <PillLabel>{department.toUpperCase()}</PillLabel>
               },
               {
                  field: 'status',
                  caption: 'Status',
                  render: (status, row) => {

                     const { status_updated_by } = row;

                     return <PillLabel>
                        {status.toUpperCase()}
                        {
                           status_updated_by && <ExpandMore
                              fontSize='small'
                              className='cursor-pointer'
                              onClick={e => this.setState({
                                 statusUpdatedByAnchorEl: e.currentTarget,
                                 selectedCashRequisition: row
                              })}
                           />
                        }
                     </PillLabel>
                  }
               },
               {
                  field: 'payment_type',
                  caption: 'Payment Type',
                  render: payment_type => payment_type ? <PillLabel>{payment_type.toUpperCase()}</PillLabel> : '–'
               },
               {
                  field: 'payment_ref',
                  caption: 'Payment Ref',
                  render: payment_ref => payment_ref ? <PillLabel>{payment_ref}</PillLabel> : '–'
               },
               {
                  field: 'created_at',
                  caption: 'Date',
                  render: created_at => <DateTime value={created_at} />
               },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, row) => {

                     const isPending = row.status === CASH_REQUISITION_STATUS.PENDING;

                     return <div className='flex gap-1'>
                        <IconButton
                           size='small'
                           disabled={!canUpdate || !isPending}
                           onClick={() => this.openEditor(row)}
                        >
                           <EditIcon fontSize='small' />
                        </IconButton>
                        <IconButton
                           component={Link}
                           to={links.cashRequisition(row._id)}
                        >
                           <Visibility fontSize='small' />
                        </IconButton>
                     </div>
                  }
               }
            ]}
            rows={this.state.cash_requisitions}
            fullHeight
            pagination={{
               page: this.state.page,
               count: this.state.total,
               rowsPerPage: this.state.limit,
               labelRowsPerPage: 'Requisitions per page',
               onPageChange: (_, page) => this.setState({ page }, this.fetchCashRequisitions),
               onRowsPerPageChange: e => this.setState({ limit: e.target.value }, this.fetchCashRequisitions)
            }}
            onRefresh={this.fetchCashRequisitions}
            onAdd={isGuest ? undefined : () => this.openEditor()}
            filters={{
               onChange: filters => this.setState({ filters, page: 0 }, this.fetchCashRequisitions),
               filters: [
                  {
                     field: 'status',
                     label: 'Status',
                     type: 'select',
                     options: Object
                        .values(CASH_REQUISITION_STATUS)
                        .map(status => ({ value: status, label: status.toUpperCase() })),
                     value: this.state.filters.status,
                  },
                  {
                     field: 'from',
                     label: 'From',
                     type: 'date',
                     value: this.state.filters.from,
                  },
                  {
                     field: 'to',
                     label: 'To',
                     type: 'date',
                     value: this.state.filters.to,
                  },
                  {
                     field: 'department',
                     label: 'Department',
                     type: 'select',
                     options: Object
                        .values(DEPARTMENT)
                        .map(department => ({ value: department, label: department.toUpperCase() }))
                     ,
                     value: this.state.filters.department
                  }
               ]
            }}
         />
         {
            this.state.editorOpen && <Editor
               onClose={this.closeEditor}
               data={this.state.selectedCashRequisition}
            />
         }
         {
            this.state.statusUpdatedByAnchorEl && <Menu
               anchorEl={this.state.statusUpdatedByAnchorEl}
               open={Boolean(this.state.statusUpdatedByAnchorEl)}
               onClose={() => this.setState({ statusUpdatedByAnchorEl: null, selectedCashRequisition: null })}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
               }}
            >
               <div className='text-xs p-2 text-gray-600'>
                  <b className='capitalize'>
                     {this.state.selectedCashRequisition.status}
                  </b> by <b className='capitalize'>
                     {this.state.selectedCashRequisition?.status_updated_by ? `${this.state.selectedCashRequisition.status_updated_by.name} ${this.state.selectedCashRequisition.status_updated_by.surname}` : '–'}
                  </b>
               </div>
            </Menu>
         }
      </>
   }
}


const mapStateToProps = state => ({
   user: state.user
});

const CashRequisitionList = connect(mapStateToProps)(_CashRequisitionList);

export default CashRequisitionList;